import React, { useEffect, useRef, useState } from "react";
import OtpInput from "react-otp-input";
import SimpleButton from "../common/buttons/SimpleButton/SimpleButton";
import { EditProfileLoader } from "../common/loader";
import { InputErrorMessage } from "../errorMessages";
import Countdown from "../Countdown/Countdown";

function VerifyConfirmation({
  email,
  popupStatus = false,
  verifyPage = false,
  onConfirm,
  onVerifyOtp,
  isleft,
  isWrongOtp,
  setIsWrongOtp,
  errorMsg,
  setErrorMsg,
  sendheader,
  verifyheader,
  closefun
}) {
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");

  const handleSendOtp = async () => {
    setLoading(true);
    try {
      await onConfirm();
    } catch (error) {
      console.error("Error sending OTP:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async () => {
    setLoading(true);
    try {
      if (otp.length < 6) {
        setLoading(false);
        setIsWrongOtp(true);
        setErrorMsg("Please enter 6 digits otp");
      } else {
        const verify = await onVerifyOtp(otp);
        console.log(verify)
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
    } finally {
      setLoading(false);
    }
  };

  const getMaskedEmail = (email) => {
    const [local, domainFull] = email.split("@");
    const [domain, tld] = domainFull.split(".");

    const maskedLocal =
      local.length > 2
        ? local.slice(0, 2) + "*".repeat(local.length - 2)
        : "*".repeat(local.length);

    const maskedDomain =
      domain.length > 2
        ? domain.slice(0, 2) + "*".repeat(domain.length - 2)
        : "*".repeat(domain.length);

    return `${maskedLocal}@${maskedDomain}.${tld}`;
  };

  const handleOtpInput = (otp) => {
    setOtp(otp);
    if (otp.length < 6) {
      setIsWrongOtp(true);
      setErrorMsg("Please enter otp");
    }
    else {
      setIsWrongOtp(false);
      setErrorMsg("");
    }

  };
  return (
    <div
      className={`fixed top-0 right-0 bottom-0 z-[90] flex items-center justify-center transition-opacity duration-200
        ${popupStatus ? "opacity-100 visible" : "opacity-0 invisible"}
        bg-black bg-opacity-40 w-full
        ${isleft && 'lg:w-[calc(100%-240px)] lg:ml-[240px]'} px-4 sm:px-6`}
    >

      <div className="relative bg-white  rounded-xl shadow-lg space-y-6 w-full max-w-sm">
        {
          closefun && (
             <p onClick={closefun} className="absolute cursor-pointer top-[10px] right-[10px] text-gray-500 text-sm font-medium p-2 cursor-pointer xl:block">
          close
        </p>
          )
        }
       
        <div className="py-4 px-6 py-8">
          <h2 className="text-center font-semibold text-base sm:text-lg mb-2">
            Verification Required
          </h2>



          {!verifyPage ? (
            <>
              {sendheader}
              <p className="font-semibold text-center !m-0">{getMaskedEmail(email)}</p>.
              <SimpleButton
                title={loading ? <EditProfileLoader /> : "Send OTP"}
                buttonType="primary"
                customClass="rounded-md w-full"
                onClickEvent={(e) => {
                  e.preventDefault();
                  handleSendOtp();
                }}
              />
            </>
          ) : (
            <>
              {verifyheader}
              <p className="font-semibold text-center !m-0">{getMaskedEmail(email)}</p>.

              <OtpInput
                inputStyle={{
                  width: "35px",
                  height: "40px",
                  fontSize: "1.25rem",
                  borderRadius: "0.5rem",
                  border: "1px solid #ccc",
                }}
                numInputs={6}
                className={"text-center fs-3 otpInputt"}
                errorStyle={{ border: "solid 1px red" }}
                hasErrored={isWrongOtp}
                isInputNum
                inputType="number"
                value={otp}
                onChange={(otp) => handleOtpInput(otp)}
                separator={<span> </span>}
                containerStyle={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "1rem", // spacing between inputs
                  marginTop: "1rem", // or any spacing needed
                }}
              />
              {
                errorMsg &&
                <div className="flex justify-center items-center">
                  <InputErrorMessage
                    error={errorMsg}
                  />
                </div>

              }
              < div className="flex items-center justify-center flex-col mt-[17px]">
                <Countdown initialSeconds={60} resendOtp={handleSendOtp} />
              </div>
              <SimpleButton
                title={loading ? <EditProfileLoader /> : "Verify OTP"}
                buttonType="primary"
                customClass="rounded-md w-full mt-[16px]"
                onClickEvent={(e) => {
                  e.preventDefault();
                  handleVerify();
                }}
              />
            </>
          )}

        </div>
      </div>
    </div>
  );
}

export default VerifyConfirmation;
